/**
 * Generated by scripts/stamp-build.mjs before each `expo export`. Do
 * not edit by hand — your changes will be overwritten on the next build.
 * Falls back to "dev" when running the local dev server (which doesn't
 * invoke this script).
 */
export const BUILD_STAMP = '2026-09-10.2236';
export const BUILD_BUILT_AT: string | null = '2026-09-11T02:36:40.530Z';
